import { useEffect, useState } from 'react';

import debounce from 'lodash/debounce';

import { useFlag } from '../../services/launchDarkly';
import { useStores } from '../../stores/useStores';

import { CCC_HEADER_CLASSNAME, GAME_UI_HEADER_CLASSNAME } from './constants';

export function useHeaderHeight() {
  const { gameStore } = useStores();

  const [headerHeight, setHeaderHeight] = useState(0);
  const isOldSearchMode = useFlag('enable_old_search_mode', false);

  const listener = debounce((header: HTMLDivElement) => {
    const { clientHeight } = header;

    setHeaderHeight(clientHeight);
    document.documentElement.style.setProperty('--header-height', `${clientHeight}px`);
  }, 60);

  useEffect(() => {
    const className = gameStore.showGameUi ? GAME_UI_HEADER_CLASSNAME : CCC_HEADER_CLASSNAME;
    let observer: MutationObserver | undefined;

    const attach = () => {
      const header = document.querySelector<HTMLDivElement>(`.${className}`);

      if (!header) {
        return false;
      }

      observer = new MutationObserver(() => {
        listener(header);
      });

      observer.observe(header, {
        childList: true,
      });

      listener(header);

      return true;
    };

    if (!attach()) {
      const bodyObserver = new MutationObserver(() => {
        if (attach()) {
          bodyObserver.disconnect();
        }
      });

      bodyObserver.observe(document.body, { childList: true, subtree: true });

      return () => {
        bodyObserver.disconnect();
        observer?.disconnect();
      };
    }

    return () => {
      observer?.disconnect();
    };
  }, [isOldSearchMode, listener, gameStore.showGameUi]);

  return { headerHeight };
}
